import { END_POINTS } from '../constants/urls';
import { OTP_TYPES } from '../constants/enums';
import { CommonBody } from '../types/General';
import { User } from '../types/User';
import emptySplitApi from '../utils/rtk';

interface CommonResponseType {
  statusCode: number;
  message: string;
}

export const authApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    postLogIn: builder.mutation<
      CommonResponseType & { data: User },
      CommonBody //is here
    >({
      query: (body) => ({
        url: END_POINTS.login,
        method: 'POST',
        body,
      }),
    }),
    getUser: builder.query<CommonResponseType & { data: User }, {}>({
      query: () => ({
        url: END_POINTS.get_user,
        method: 'GET',
      }),
    }),
    logout: builder.query<CommonResponseType, {}>({
      query: () => ({
        url: END_POINTS.logout,
        method: 'GET',
      }),
    }),
    forgotPassword: builder.mutation<CommonResponseType, CommonBody>({
      query: (body) => ({
        url: END_POINTS.forgotPassword,
        method: 'POST',
        body: { ...body, type: OTP_TYPES.FORGET },
      }),
    }),
    postVerifyOtp: builder.mutation<CommonResponseType & { data: User }, CommonBody>({
      query: (body) => ({
        url: END_POINTS.verifyOtp,
        method: 'POST',
        body,
      }),
    }),
    resetPassword: builder.mutation<CommonResponseType, CommonBody>({
      query: (body) => ({
        url: END_POINTS.resetPassword,
        method: 'POST',
        body,
      }),
    }),
    putUpdateProfile: builder.mutation<CommonResponseType & { data: any }, CommonBody>({
      query: (body) => ({
        url: END_POINTS.updateProfile,
        method: 'PUT',
        body,
      }),
    }),
    postChangePassword: builder.mutation<CommonResponseType, CommonBody>({
      query: (body) => ({
        url: END_POINTS.changePassword,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const {
  usePostLogInMutation,
  useForgotPasswordMutation,
  usePostVerifyOtpMutation,
  useResetPasswordMutation,
  useLazyGetUserQuery,
  useGetUserQuery,
  useLazyLogoutQuery,
  usePostChangePasswordMutation,
  usePutUpdateProfileMutation,
} = authApi;
